export default __webpack_public_path__ + "static/media/bg_music1.061b868e.mp3";